import Logo from "./Logo";
import { SUPPORT_EMAIL } from "../config";

const LEGAL = [
    ["Privacy Policy", "#/privacy", "privacy"],
    ["Terms of Service", "#/terms", "terms"],
    ["Refund Policy", "#/refund", "refund"],
];

export default function Footer() {
    const year = new Date().getFullYear();
    return (
        <footer
            data-testid="footer-section"
            className="bg-emerald-50 px-4 py-12 text-center sm:py-14"
        >
            <div className="mx-auto flex max-w-2xl flex-col items-center">
                <Logo size={30} />
                <p className="mt-4 text-sm text-slate-700 sm:text-[15px]">
                    © {year} Drvn Dream. All rights reserved.
                </p>
                <p className="mt-4 text-xs leading-relaxed text-slate-500 sm:text-[13px]">
                    This is a digital product. All ebooks are delivered
                    digitally. No physical products will be shipped.
                    <br className="hidden sm:block" /> Results may vary based
                    on individual effort and application of knowledge.
                </p>
                <nav className="mt-5 flex flex-wrap items-center justify-center gap-x-8 gap-y-2 text-sm">
                    {LEGAL.map(([label, href, id]) => (
                        <a
                            key={id}
                            href={href}
                            data-testid={`footer-legal-${id}`}
                            className="text-slate-600 transition-colors hover:text-emerald-700"
                        >
                            {label}
                        </a>
                    ))}
                    <a
                        href={`mailto:${SUPPORT_EMAIL}`}
                        data-testid="footer-contact-support"
                        className="text-slate-600 transition-colors hover:text-emerald-700"
                    >
                        Contact Support
                    </a>
                </nav>
            </div>
        </footer>
    );
}
